import * as util from "./util"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Become a Host Page Viewed")
  }

  window.tfSignUpQuestionChanged = function (data) {
    SharesyWebflow.logAmplitudeEvent("Host Sign Up Typeform Question Change", {
      question: data.ref,
    })
  }
  window.tfSignUpReady = function () {
    SharesyWebflow.logAmplitudeEvent("Host Sign Up Typeform Ready")
  }
  window.tfSignUpSubmit = function () {
    SharesyWebflow.logAmplitudeEvent("Host Sign Up Typeform Submit")
  }
  window.tfSignUpClose = function () {
    SharesyWebflow.logAmplitudeEvent("Host Sign Up Typeform Close")
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    const searchParams = util.getSearchParams()
    const referrer = searchParams.get("referrer")

    function logAmplitudeEvent(eventName, eventProps) {
      let eventProperties = {}
      if (eventProps) {
        eventProperties = eventProps
      }
      try {
        eventProperties["Referrer"] = referrer
      } catch (err) {}
      util.logAmplitudeEvent(eventName, eventProperties)
    }

    function init() {
      // Typeform - set the hidden fields, then embed typeform (need to add script
      // after otherwise the hidden fields are ignored).
      try {
        try {
          if (referrer) {
            document.getElementById("list-your-spaces-top").dataset.tfHidden =
              "referrer=" + referrer
            document.getElementById(
              "list-your-spaces-bottom"
            ).dataset.tfHidden = "referrer=" + referrer
          }
        } catch (err) {
          util.logToSentry(err)
        }

        let script = document.createElement("script")
        script.src = "//embed.typeform.com/next/embed.js"
        document.head.appendChild(script)
      } catch (err) {
        util.logToSentry(err)
      }

      // Open and close Hubspot modal
      try {
        document
          .getElementById("get-a-demo-top")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "block"
            logAmplitudeEvent("Host Get a Demo Top")
          })
      } catch (err) {
        util.logToSentry(err)
      }
      try {
        document.getElementById("close-dark").addEventListener("click", (e) => {
          document.getElementById("modal-container").style.display = "none"
          // Ensure video doesn't keep playing when modal is closed
          document.getElementById("loom-iframe").src += ""
          logAmplitudeEvent("Host Close Modal")
        })
      } catch (err) {
        util.logToSentry(err)
      }
      try {
        document
          .getElementById("modal-container")
          .addEventListener("click", (e) => {
            if (e.target.id === "modal-container") {
              document.getElementById("modal-container").style.display = "none"
              // Ensure video doesn't keep playing when modal is closed
              document.getElementById("loom-iframe").src += ""
              logAmplitudeEvent("Host Close Modal Click Outside")
            }
          })
      } catch (err) {
        util.logToSentry(err)
      }

      // FAQ expand/collapse
      try {
        util.faqExpandCollapse("Host FAQ")
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
      logAmplitudeEvent: logAmplitudeEvent,
    }
  })()
}
